import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PosCreditRequestCompanyBankingReferencesModalComponent } from 'src/app/shared/pos-credit-request-company-banking-references-modal/pos-credit-request-company-banking-references-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosCreditRequestCompanyBankingReferencesModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) { }

  show(form: FormGroup, confirmAction: (form: FormGroup) => any) {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosCreditRequestCompanyBankingReferencesModalComponent);
      this.modalRef.setClass(`modal-dialog modal-md ${ModalDialogType.PRIMARY}`);
      this.modalRef.content.form = form;
      this.modalRef.content.confirmAction = confirmAction;
      resolve(true);
    });
  }
}
